import { render } from "./connection_detail.vue?vue&type=template&id=096b9c60"
import script from "./connection_detail.vue?vue&type=script&lang=js"
export * from "./connection_detail.vue?vue&type=script&lang=js"

import "./connection_detail.vue?vue&type=style&index=0&id=096b9c60&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__